import React, { useCallback, useEffect, useState } from 'react';
import AppLayout from './components/AppLayout';
import HomeworkTable from './components/HomeworkTable';
import PageHeader from './components/PageHeader';
import { fetchClassDashboards, fetchHomework } from './services/whiteboardApi';
import { mergeClassDashboards } from './utils/classDashboard';
import { getStoredClassTokens } from './utils/classTokens';
import { getStoredBoard, selectedGroupTokens } from './utils/subjectGroups';
import { getLocalDateString } from './utils/date';
import { buildClassHomeworkTable, buildHomeworkTable } from './utils/tableData';

function HomeworkHistory() {

    const [tableData, setTableData] = useState();
    const [maxCol, setMaxCol] = useState(0);
    const [maxRow, setMaxRow] = useState(0);
    const [subjectTags, setSubjectTags] = useState(new Map());
    const [date, setDate] = useState(getLocalDateString);
    const [classTokens] = useState(() => selectedGroupTokens().length
        ? selectedGroupTokens()
        : getStoredClassTokens());
    const [boardId] = useState(getStoredBoard);

    const name = localStorage.getItem('name');

    const fetchData = useCallback(async () => {
        try {
            const data = classTokens.length
                ? mergeClassDashboards((await fetchClassDashboards(classTokens, date, boardId)).dashboards)
                : await fetchHomework(name, date);
            const table = classTokens.length
                ? buildClassHomeworkTable(data.assignments)
                : buildHomeworkTable(data.table);

            setMaxCol(table.maxCol);
            setMaxRow(table.maxRow);
            setTableData(table.tableData);
            setSubjectTags(table.subjectTags || new Map());

        } catch (error) {
            console.error('There was a problem with the POST request:', error);
        }
        
    }, [boardId, classTokens, date, name]);

    useEffect( () => {
          
        fetchData();

    }, [fetchData]);
    
    return (
        <AppLayout>
            <div className="mx-auto flex w-full max-w-6xl flex-col items-center">
                <PageHeader
                    title={`${date}'s Homework`}
                    compact
                    action={
                        <input
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            className="rounded-md border border-gray-300 bg-white p-2 text-base shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    }
                    description={`Below is the list of tasks and their corresponding deadlines for ${date}. Please make sure to review and complete your tasks on time.`}
                />
                <HomeworkTable
                    tableData={tableData}
                    maxRow={maxRow}
                    maxCol={maxCol}
                    subjectTags={subjectTags}
                    fitToWidth
                />
            </div>
        </AppLayout>
    );
  
}

export default HomeworkHistory;
